import { Component } from '@angular/core';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import {
  ModalController,
  Platform,
  RefresherCustomEvent,
  ToastController
} from '@ionic/angular';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import {
  BrukerResponse,
  KeycloakUserProfile,
  KundeResponse
} from 'src/app/services/bruker/bruker.types';
import { KeycloakService } from 'keycloak-angular';
import { HttpClient } from '@angular/common/http';
import { SlettebrukerComponent } from './slettebruker/slettebruker/slettebruker.component';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { Router } from '@angular/router';
import { InformationService } from 'src/app/services/notify/information.service';
import { InformationMessage } from 'src/app/services/notify/information.types';

@Component({
  selector: 'app-profil',
  templateUrl: 'profil.page.html',
  styleUrls: ['profil.page.scss']
})
export class ProfilPage {
  userInfo: KeycloakUserProfile;
  mobilnummerGroup: FormGroup;
  kundenummerkodeGroup: FormGroup;
  kundenummerkode: boolean;
  mobilnummerForceHide = false;
  _kundeResponse: Observable<KundeResponse>;
  loggedIn: boolean;
  smsEnabled: boolean;
  modalPage: any;
  invalidMobileNumber: boolean = false;
  smsSubscription: Subscription;
  kodeSubscription: Subscription;
  infoMessages: InformationMessage[] = [];

  constructor(
    private iab: InAppBrowser,
    private router: Router,
    public platform: Platform,
    private _keycloakService: KeycloakService,
    private _httpClient: HttpClient,
    private _toast: ToastController,
    public modalCtrl: ModalController,
    private analyticsService: AnalyticsService,
    public infoService: InformationService
  ) {
    this.smsEnabled = false;
    this.kundenummerkode = false;
    this.mobilnummerGroup = new FormGroup({
      mobilnummer: new FormControl('')
    });
    this.kundenummerkodeGroup = new FormGroup({
      kode: new FormControl('')
    });
    this.loggedIn = _keycloakService.isLoggedIn();
  }

  ionViewDidEnter() {
    this.infoService.getInfoMessages().subscribe({
      next: (res) => {
        this.infoMessages = res.filter((x) => x.aktivert) || [];
      }
    });
    this.setUserinfo();
  }

  ionViewWillLeave() {
    this.smsSubscription?.unsubscribe();
    this.kodeSubscription?.unsubscribe();
  }

  async setUserinfo() {
    if (this.loggedIn) {
      this.userInfo = await this.getUserInfo();
    }
  }

  getUserInfo(): Promise<Keycloak.KeycloakProfile> {
    return this._keycloakService.loadUserProfile(true);
  }

  async doRefresh(myevent: RefresherCustomEvent) {
    this.setUserinfo();
    myevent.detail.complete();
  }

  async sendSms() {
    const mobilnr: string = this.mobilnummerGroup.get('mobilnummer').value;
    this.mobilnummerGroup.reset();
    this.smsSubscription = this.DosendSms(mobilnr).subscribe({
      next: (response) => {
        if (response.connected) {
          this._toast
            .create({
              message: response.message,
              duration: 4000,
              position: 'top',
              color: 'success'
            })
            .then((toast) => toast.present())
            .catch((response) => {
              this._toast
                .create({
                  message: response.message,
                  duration: 4000,
                  position: 'top'
                })
                .then((toast) => toast.present());
            })
            .finally(() => {
              this.kundenummerkode = true;
            });
        }
        if (response.connected === false && response.kunde_id === null) {
          this.invalidMobileNumber = true;
        }
      }
    });
  }

  async sendKode() {
    const kode: string = this.kundenummerkodeGroup.get('kode').value;
    this.kundenummerkodeGroup.reset();
    this.kodeSubscription = this.DosendKode(kode).subscribe({
      next: (response) => {
        this._toast
          .create({
            message:
              response.message +
              '\nDu blir nå logget ut og må logge inn igjen.',
            duration: 4000,
            position: 'top',
            color: 'success'
          })
          .then((toast) => toast.present());
      },
      error: (err) => {
        this._toast
          .create({
            message: 'Feil oppsto\nDu blir nå logget ut og må logge inn igjen.',
            duration: 4000,
            position: 'top',
            color: 'danger'
          })
          .then((toast) => toast.present());
      }
    });

    this.kundenummerkode = false;
    this.mobilnummerForceHide = true;
    await this.delay(4000);
  }

  delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  DosendSms(mobilnummer: string): Observable<BrukerResponse> {
    return this._httpClient.post<BrukerResponse>(
      'https://apiprivat.ishavskraft.no/bruker/koble/mobilnr/' + mobilnummer,
      null
    );
  }

  DosendKode(kode: string): Observable<BrukerResponse> {
    if ('serviceWorker' in navigator) {
      caches.keys().then(function (cacheNames) {
        cacheNames.forEach(function (cacheName) {
          caches.delete(cacheName);
        });
      });
    }
    return this._httpClient.post<BrukerResponse>(
      'https://apiprivat.ishavskraft.no/bruker/koble/kode/' + kode,
      null
    );
  }

  navigateToFeedback() {
    if (this.platform.is('android')) {
      this.iab.create(
        'https://www.netigate.se/ra/s.aspx?s=907197X239153449X12016',
        '_self'
      );
    } else {
      //IOS
      const browser = this.iab.create(
        'https://www.netigate.se/ra/s.aspx?s=907197X239153449X12016',
        '_blank',
        'location=no'
      );
      browser.show();
    }
  }

  async deleteKCUser() {
    if (!this.userInfo) {
      this.userInfo = await this._keycloakService
        .getKeycloakInstance()
        .loadUserInfo();
    }
    if (this.userInfo) {
      this.modalPage = await this.modalCtrl.create({
        component: SlettebrukerComponent,
        cssClass: 'slette-bruker-modal-content',
        backdropDismiss: true,
        componentProps: { userInfo: this.userInfo }
      });
      this.analyticsService.logEvent_selectContent('profil åpne slett-bruker');
      await this.modalPage.present();
    } else {
      this._toast
        .create({
          message:
            'Kunne ikke hente brukerinfo. Vennligst prøv igjen eller kontakt oss om problemet vedvarer.',
          duration: 8000,
          position: 'middle',
          color: 'danger'
        })
        .then((toast) => {
          toast.present();
        });
    }
  }
}
